import { BaseModel, NilToNull } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';
import { GenericAddress } from '../type';

@Exclude()
export class OneMapAddress extends BaseModel implements GenericAddress {
  @Expose({ name: 'POSTAL' })
  @NilToNull()
  postalCode!: string;

  @Expose({ name: 'BLK_NO' })
  @NilToNull()
  blockNumber!: string;

  @Expose({ name: 'ROAD_NAME' })
  @NilToNull()
  streetName!: string;

  @Expose({ name: 'BUILDING' })
  @NilToNull()
  buildingName!: string;

  @Expose({ name: 'ADDRESS' })
  @NilToNull()
  address!: string;
}
